import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

const POLL_INTERVAL = 4000

// Keeps the export toasts fresh without a WebSocket. Passenger (open source)
// pins one app process to every open /cable connection, so a few open tabs
// starved the pool. Instead, poll the server only while an export is running
// (a toast marked data-processing) and the tab is visible; the response is a
// Turbo Stream that re-renders this container, and polling stops by itself once
// nothing is processing.
export default class extends Controller {
  static values = { url: String }

  connect() {
    this.observer = new MutationObserver(() => this.sync())
    this.observer.observe(this.element, { childList: true, subtree: true })
    this.onVisibilityChange = () => this.sync()
    document.addEventListener("visibilitychange", this.onVisibilityChange)
    this.sync()
  }

  disconnect() {
    this.observer.disconnect()
    document.removeEventListener("visibilitychange", this.onVisibilityChange)
    this.stop()
  }

  sync() {
    if (this.processing && !document.hidden) this.start()
    else this.stop()
  }

  get processing() {
    return this.element.querySelector("[data-processing]") !== null
  }

  start() {
    this.timer ||= setInterval(() => this.poll(), POLL_INTERVAL)
  }

  stop() {
    clearInterval(this.timer)
    this.timer = null
  }

  async poll() {
    if (this.polling) return
    this.polling = true
    try {
      await get(this.urlValue, { responseKind: "turbo-stream" })
    } finally {
      this.polling = false
    }
  }
}
